import { render, staticRenderFns } from "./HolidayPlanner.vue?vue&type=template&id=772fca80"
import script from "./HolidayPlanner.vue?vue&type=script&lang=js"
export * from "./HolidayPlanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports